export const readAuthErrorHandled = ({ is_auth_error_handled }) => is_auth_error_handled